import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Settings } from "luxon";
import Landing from "pages/landing/Landing";
import { AuthProvider } from "contexts/AuthContext";

const AppShell = lazy(() => import("./AppShell"));

function App() {
  Settings.defaultLocale = "pt-BR";

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route index element={<Landing />}></Route>
          <Route
            path="*"
            element={
              <Suspense fallback={null}>
                <AppShell />
              </Suspense>
            }
          ></Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
